import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Rocket } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
export function LaunchCTA() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 px-6 bg-zinc-950 border-y border-zinc-900" data-id="element-110">
      <div className="max-w-3xl mx-auto text-center" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} data-id="element-112">
          <p className="text-sm uppercase tracking-widest text-zinc-500 font-medium mb-4" data-id="element-113">
            {t('ctas.launch.tag')}
          </p>
          <h2 className="font-serif text-3xl md:text-4xl mb-6 text-zinc-100" data-id="element-114">
            {t('ctas.launch.title')}
          </h2>
          <p className="text-zinc-400 mb-10 text-lg" data-id="element-115">{t('ctas.launch.desc')}</p>
          <motion.div animate={{
          boxShadow: ['0 0 0 0 rgba(16, 185, 129, 0.45)', '0 0 0 10px rgba(16, 185, 129, 0)', '0 0 0 0 rgba(16, 185, 129, 0)'],
          scale: [1, 1.01, 1]
        }} transition={{
          duration: 2.8,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="inline-block rounded-full" data-id="element-116">
            <Link to="/launch" className="inline-flex items-center gap-3 px-8 py-3.5 bg-emerald-600 text-white rounded-full font-medium text-base hover:bg-emerald-500 transition-colors group shadow-lg shadow-emerald-600/25" data-id="element-117">
              <Rocket className="w-5 h-5" data-id="element-118" />
              {t('ctas.launch.btn')}
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-119" />
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}